// LOT 51 · 3.2 · jamais « — » seul : la raison (« pas de pointage », « attend la caisse ») ou « à compléter »
export const estVide = (v) => v == null || v === '' || v === '—' || v === '–';
export const raisonDe = (x) => x?.raison || x?.vide_raison || (String(x?.label || '').split(' · ')[1]) || 'à compléter';
export const valeurOu = (x, v = x?.valeur) => (estVide(v) ? raisonDe(x) : v);
